"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.772 4.601c.565-.842 1.477-1.497 2.754-1.497.972 0 1.73.27 2.299.767.555.485.857 1.125 1.044 1.738a.7.7 0 1 1-1.339.408c-.147-.483-.346-.846-.626-1.092-.268-.233-.678-.42-1.378-.42-.728 0-1.237.349-1.591.877-.37.55-.55 1.276-.55 1.892 0 .453.104.903.233 1.458l.001.005c.055.236.114.49.163.759h2.747a.7.7 0 1 1 0 1.4H8.886c-.007 1.077-.081 2.564-.898 4.148.927-.272 2.047-.424 3.159.183.845.462 1.741.305 2.594-.316a.7.7 0 0 1 .824 1.131c-1.152.84-2.636 1.208-4.09.414-.726-.397-1.508-.274-2.437.04a1.195 1.195 0 0 1-1.367-.437 1.28 1.28 0 0 1-.071-1.393c.795-1.38.877-2.687.886-3.77H5.847a.7.7 0 1 1 0-1.4h1.508q-.047-.217-.101-.447l-.012-.053c-.12-.511-.257-1.101-.257-1.722 0-.845.238-1.854.787-2.673",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CurrencyBritishPoundIcon20.js.map